import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import Footer from "../components/Footer";
import Conjugais from "../components/Conjugais";
import Scrolltop from "../components/Scrolltop";
import Header from "../components/Header";

import Bg from "../img/services/bg.jpg"

import BtWhatsapp from "../components/ButtonWhatsapp3";

const ConjugaisBreadcrumb = () => {
  return (
    <>
      <Header />
      <main>
        <Breadcrumb
          menu="Serviços"
          name="Investigação conjugal"
          bg={Bg}
        />
        <Conjugais />
        <Footer />
      </main>
      <BtWhatsapp />
      <Scrolltop />
    </>
  );
};

export default ConjugaisBreadcrumb;
